import { ComponentType, ReactNode } from "react";

import { IconComponent } from "types/Icon";
import { DocsUrl } from "utils/getDocsUrl";

import { IntegrationId } from "./registry/constants";

const tuple = <T extends string[]>(...args: T) => args;

export const IntegrationType = tuple(
  "source_code",
  "cloud",
  "communication",
  "observability",
  "idp",
  "api",
  "ai"
);
export type IntegrationType = (typeof IntegrationType)[number];

type BaseIntegration = {
  id: IntegrationId;
  name: string;
  count?: number;
  description: string;
  icon: IconComponent;
  docsLink?: DocsUrl;
  redirect?: string;
  hasViewScreen?: boolean;
  newUntil?: string; // ISO 8601 date (YYYY-MM-DD). Badge shows until end of this date.
  type: IntegrationType;
};

type IntegrationWithViewScreen = BaseIntegration & {
  hasViewScreen: true;
  docsLink?: DocsUrl;
  // component that renders the integration list view screen.
  page: ComponentType;
  // component that renders the integration details view screen.
  detailsPage?: ComponentType;
  // used to enable/disable search based on whether the original pages has search available.
  // once we're done migrating the pages, we will work on making search available for all integrations.
  hasSearch?: boolean;
};

export type IntegrationView =
  | IntegrationWithViewScreen
  | (BaseIntegration & {
      hasViewScreen?: false;
      docsLink: DocsUrl;
      page?: never;
      redirect?: never;
    })
  | (BaseIntegration & {
      hasViewScreen?: false;
      docsLink?: never;
      page?: never;
      redirect: string;
    });

export type IntegrationsOutletContext = {
  integration: IntegrationWithViewScreen;
  setLayoutActions: (actions: ReactNode) => void;
  setLayoutMeta: (meta: ReactNode) => void;
  setLayoutTitle: React.Dispatch<React.SetStateAction<string>>;
  setLayoutHeading: React.Dispatch<React.SetStateAction<ReactNode>>;
  setLayoutNavigation: (navigation: ReactNode) => void;
};
